import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Moment from "react-moment";
import { connect } from "react-redux";

export const VRTourPostsItem = ({
  tour: {
    _id,
    channelid,
    avatar,
    tourtitle,
    tourimage,
    firstname,
    companyname,
    lastname,
    location,
    likes,
    views,
    date,
  },
}) => {
  return (
    <Fragment>
      <div className="tour-container">
        <div className="tour-user-info">
          <div className="full-info">
            <img
              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/vr_tour_images/${tourimage}`}
              className="tour-image"
              alt="vr"
            />
            <div className="tour-info border-top border-bottom blue">
              <div className="user-avi-info-container">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  className="user-avi-info"
                  alt="avatar"
                />
              </div>
              <div className="info-container">
                <ul className="info-items">
                  <li className="info-item">{companyname}</li>
                  <li className="info-item">
                    {firstname} {lastname}
                  </li>
                  <li className="info-item">
                    {location && location.city}, {location && location.state}
                  </li>
                  <li className="info-item">
                    <i className="far fa-clock mr-5 blue"></i>
                    <Moment format="MM/DD/YYYY">{date}</Moment>
                  </li>
                </ul>
                <div className="views-likes">
                  <ul className="icons">
                    <li className="icon">
                      <i className="far fa-user mx-5 blue"></i>Views{" "}
                      {views && views.length}
                    </li>
                    <li className="icon">
                      <i className="far fa-thumbs-up mx-5 blue"></i>Likes{" "}
                      <span>{likes && likes.length}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tour-description-container blue">
          <p className="tour-description" id="blue-scroll">
            {tourtitle}
          </p>
          <Link to={`/vrtours/${channelid}/${_id}`}>
            <button className="watch background-blue">
              Watch<i className="far fa-play-circle mx-5 fa-lg"></i>
            </button>
          </Link>
        </div>
      </div>
    </Fragment>
  );
};

VRTourPostsItem.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(VRTourPostsItem);
